import styled from 'styled-components';
import colors from 'constants/colors';

export const BillItemContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  background-color: ${colors.black5};
  row-gap: 8px;
  padding: 16px;

  div {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: 600;

    .description {
      color: ${colors.silver};
      font-size: 14px;
      font-weight: 600;
    }

    .value {
      color: ${colors.white};
      font-size: 14px;
      font-weight: 600;
    }
  }
`;